import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { SiteScrollBlockerSiteConfig } from '../types'

const siteScrollBlockerSiteConfig: SiteConfigFn<SiteScrollBlockerSiteConfig> = ({ api }) => {
	const isBuilderComponentModel = api.rendererModel.getIsBuilderComponentModel() ?? false

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			isBuilderComponentModel,
		},
	}
}

export const name = 'siteScrollBlocker'

export const config = { site: siteScrollBlockerSiteConfig, name }
